import { render, staticRenderFns } from "./QuestionStatement.vue?vue&type=template&id=31a3bab7"
import script from "./QuestionStatement.vue?vue&type=script&lang=js"
export * from "./QuestionStatement.vue?vue&type=script&lang=js"
import style0 from "./QuestionStatement.vue?vue&type=style&index=0&id=31a3bab7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports